module.exports = __webpack_public_path__ + "static/media/tutorial-2.698cade4.jpg";